<div class="date-range-row">
  <mat-form-field class="date-field">
    <mat-label>{{ fromDateLabel }}</mat-label>
    <input
      matInput
      [matDatepicker]="fromPicker"
      [ngModel]="fromDate"
      (ngModelChange)="onFromDateChange($event)"
      (dateChange)="onFromDateChange($event.value)"
    />
    <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
    <mat-datepicker #fromPicker panelClass="user-history-compact-calendar"></mat-datepicker>
  </mat-form-field>

  <mat-form-field class="date-field">
    <mat-label>{{ toDateLabel }}</mat-label>
    <input
      matInput
      [matDatepicker]="toPicker"
      [ngModel]="toDate"
      (ngModelChange)="onToDateChange($event)"
      (dateChange)="onToDateChange($event.value)"
    />
    <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
    <mat-datepicker #toPicker panelClass="user-history-compact-calendar"></mat-datepicker>
  </mat-form-field>
</div>
